export const mapResultGalleries = (idsStr, namesStr, cleanTitlesStr) => {
  const ids = idsStr.split(',')
  const names = namesStr.split(',')
  const cleanTitles = cleanTitlesStr.split(',')
  return ids.map((id, index) => ({ id, name: names[index], cleanTitle: cleanTitles[index] }))
}

export default { mapResultGalleries }
